export default __webpack_public_path__ + "static/media/excelIcon.0b08e5eb.svg";